import { Grid, Paper } from '@mui/material';
import { AreaChart, AreaChartProps } from '../../../charts/area/area-chart.component';
import {
  LockerUtilisationChartHeader,
  LockerUtilisationChartHeaderProps
} from '../locker-utilisation-chart-header/locker-utilisation-chart-header.components';
import { useLockerUtilisationChartCardStyles } from './locker-utilisation-chart-card.styles';

export interface LockerUtilisationChartCardProps {
  HeaderProps: LockerUtilisationChartHeaderProps;
  ChartProps: AreaChartProps;
}

export function LockerUtilisationChartCard({ ChartProps, HeaderProps }: LockerUtilisationChartCardProps) {
  const classes = useLockerUtilisationChartCardStyles();
  return (
    <Paper className={classes.card}>
      <Grid container>
        <Grid container style={{ marginBottom: '16px' }}>
          <LockerUtilisationChartHeader {...HeaderProps} />
        </Grid>
        <div className={classes.divider}></div>
        <Grid container>
          <AreaChart {...ChartProps} />
        </Grid>
      </Grid>
    </Paper>
  );
}
